import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import slugify from "slugify"
import * as Reach from "@reach/accordion"
import "@reach/accordion/styles.css"

import { Decorator } from "components"

import Item from "./_Item"

function LocationList({ heading, image, locationTypes, subheading }) {
  const { locations } = useStaticQuery(LOCATION_QUERY)

  // sort states
  let states = []
  locations?.nodes?.forEach(
    ({ address, city, facilityType, state, recruitingLink }) => {
      locationTypes.forEach(locationType => {
        if (
          recruitingLink?.recruitingLink &&
          state &&
          city &&
          facilityType?.name === locationType?.name
        ) {
          let foundState = -1
          states.forEach((innerState, index) => {
            if (innerState.state === state) {
              foundState = index
            }
          })
          if (foundState === -1) {
            states.push({
              state: state,
              cities: [{ address, city, facilityType, recruitingLink }],
              count: 1,
            })
          } else {
            states[foundState].count++
            states[foundState].cities.push({
              address,
              city,
              facilityType,
              recruitingLink,
            })
          }
        }
      })
    }
  )
  states = states.sort((a, b) => (a.state > b.state ? 1 : -1))

  return (
    <section
      data-slice="LocationList"
      id={slugify(heading && heading)}
      className="relative pt-0 pb-8 md:pt-40 wrapper default-grid md:pb-16 gap-y-0"
    >
      <div className="relative h-40 col-span-2 row-span-1 row-start-1 lg:h-auto lg:col-span-2">
        {image && (
          <Decorator
            className="absolute top-0 hidden -translate-x-full -translate-y-1/2 md:block left-full"
            asset={image}
            size="large"
          />
        )}
        {image && (
          <Decorator
            className="absolute top-0 -translate-x-full md:hidden left-full"
            asset={image}
            size="small"
          />
        )}
      </div>
      <div className="space-y-8 md:col-start-3 md:col-span-8 col-span-full md:space-y-10">
        <div className="space-y-4">
          {heading && <h2 className="h3 text-darkNavy">{heading}</h2>}
          {subheading && (
            <p className="lead-copy text-darkNavy">
              {subheading?.internal?.content}
            </p>
          )}
        </div>
        <Reach.Accordion
          as="ul"
          className="border-t border-opacity-50 divide-y border-mineralGray divide-mineralGray divide-opacity-50"
          collapsible={true}
          multiple={true}
        >
          {states?.map((item, i) => (
            <Item {...item} key={`item--${i}`} />
          ))}
        </Reach.Accordion>
      </div>
    </section>
  )
}

export default LocationList

const LOCATION_QUERY = graphql`
  {
    locations: allContentfulLocation {
      nodes {
        recruitingLink {
          recruitingLink
        }
        state
        city
        address {
          raw
        }
        facilityType {
          name
        }
      }
    }
  }
`
